import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"




export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    loading: { type: Boolean },
    type: {},
    onClick: {}
  },
  setup(__props: any) {

const props = __props

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (props.type === 'cancel')
      ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          class: "btn-footer btn-cancel",
          type: "primary",
          plain: "",
          loading: props.loading,
          onClick: props.onClick
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('form.cancel')), 1)
          ]),
          _: 1
        }, 8, ["loading", "onClick"]))
      : _createCommentVNode("", true),
    (props.type === 'confirm')
      ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          class: "btn-footer btn-confirm",
          type: "primary",
          loading: props.loading,
          onClick: props.onClick
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('form.confirm')), 1)
          ]),
          _: 1
        }, 8, ["loading", "onClick"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})